<template>
  <router-view></router-view>
</template>

<style lang="scss">
.contract {
  font-size: 14px;
  padding: 5px 7px;
  padding-left: 8px;
  display: inline-flex;
  align-items: center;

  span {
    padding-top: 2px;
  }
}
</style>

<script>
export default {};
</script>
